import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { useApiKeyActions } from '@/features/apiKeys/hooks/useApiKeyActions'
import { useRequiredOrgId } from '@/hooks/useRequiredOrgId'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'

export const DeleteApiKeyDialog = ({
  keyId,
  onClose,
}: {
  keyId: string | null
  onClose: () => void
}) => {
  const organizationId = useRequiredOrgId()
  const { deleteKey } = useApiKeyActions()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(!!keyId)
  }, [keyId])

  const handleDelete = () => {
    if (!keyId) return
    deleteKey.mutate(
      { organizationId, keyId },
      {
        onSuccess: () => {
          onClose()
          toast.success('API Key deleted', {
            description: 'API key deleted successfully',
          })
        },
        onError: (error) => {
          toast.error('Error deleting API Key', {
            description: error.message,
          })
        },
      },
    )
  }

  return (
    <AlertDialog
      open={open}
      onOpenChange={(open) => {
        if (!open) {
          onClose()
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete API Key</AlertDialogTitle>
          <AlertDialogDescription>
            This will permanently remove the API key from your organization.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <p className="text-sm text-muted-foreground">
          Are you sure you want to delete this API key? This action is
          irreversible.
        </p>
        <AlertDialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={deleteKey.isPending}
          >
            Confirm
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
